<template>
  <component
    :is="tag"
    :style="{ color: color }"
    class="configurator-colored-dot"
    :title="title && ucFirst(title)"
    :class="{
      'configurator-colored-dot--variant': variant,
      'configurator-colored-dot--dark-border': hasDarkBorder(color),
      'configurator-colored-dot--active': active,
    }"
  />
</template>

<script>
import { colorContrast } from '../../utils/ColorUtils';
import { ucFirst } from '../../utils/String';

export default {
  name: 'ConfiguratorColoredDot',
  props: {
    color: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: undefined,
    },
    active: Boolean,
    variant: Boolean,
    tag: {
      type: String,
      default: 'div',
    },
  },
  methods: {
    hasDarkBorder(color) {
      return colorContrast(color, false, true, 224);
    },
    ucFirst,
  },
};
</script>

<style scoped lang="scss">
.configurator-colored-dot {
  $base-selector: &;

  display: block;
  width: 1em;
  min-width: 1em;
  height: 1em;
  border-radius: 50%;
  background-color: currentColor;
  border: solid 1px currentColor;
  cursor: pointer;
  transition: border $default-transition-duration;
  color: $color-white;

  &--dark-border {
    border-color: $color-gray-silver;
  }

  &--active,
  &:hover {
    border-color: $color-primary;
  }

  &:hover {
    &:before {
      border-color: $color-gray-silver;
    }
  }

  &--variant {
    $border-width: 1px;

    position: relative;
    border-color: $color-gray-silver;
    border-width: $border-width;
    margin: $border-width * 3;

    &:before {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: 0.875rem;
      height: 0.875rem;
      transform: translate(-50%, -50%);
      border-radius: 50%;
      transition: background-color $default-transition-duration;
    }

    &#{$base-selector}--active {
      &:before {
        background-color: $color-secondary;
      }
    }
  }
}
</style>
